import { format } from "date-fns";

export interface BirthDayTimeAndQnt {
  date: string;
  time: string;
  qnt: number;
}

export const initialBirthDayTimeAndQnt = {
  date: format(new Date(), "yyyy-MM-dd"),
  time: "",
  qnt: 1
} as BirthDayTimeAndQnt;
